var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGmeetBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2016_18344",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2016_18344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33293 16.6665C2.87459 16.6665 2.48237 16.5034 2.15626 16.1773C1.82959 15.8506 1.66626 15.4581 1.66626 14.9998V4.9998C1.66626 4.54146 1.82959 4.14924 2.15626 3.82313C2.48237 3.49646 2.87459 3.33313 3.33293 3.33313H13.3329C13.7913 3.33313 14.1838 3.49646 14.5104 3.82313C14.8365 4.14924 14.9996 4.54146 14.9996 4.9998V8.7498L18.3329 5.41646V14.5831L14.9996 11.2498V14.9998C14.9996 15.4581 14.8365 15.8506 14.5104 16.1773C14.1838 16.5034 13.7913 16.6665 13.3329 16.6665H3.33293ZM3.33293 14.9998H13.3329V4.9998H3.33293V14.9998Z",
    fill: "#366EE3"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmeetBlue);
export default __webpack_public_path__ + "static/media/gmeet_blue.40c55e702574a09e16c1ebcdd1da1c23.svg";
export { ForwardRef as ReactComponent };